import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFilezillaComponent } from './simple-icons-filezilla.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFilezillaComponent ],
    exports:      [ SimpleIconsFilezillaComponent ],
    bootstrap:    []
})
export class SimpleIconsFilezillaModule {}
